import { render } from "./ServiceTileItem.vue?vue&type=template&id=7130f7e6&scoped=true&ts=true"
import script from "./ServiceTileItem.vue?vue&type=script&lang=ts"
export * from "./ServiceTileItem.vue?vue&type=script&lang=ts"

import "./ServiceTileItem.vue?vue&type=style&index=0&id=7130f7e6&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7130f7e6"]])

export default __exports__